import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

interface SpaCaseOfNeed extends Vue {
    objectDetails: any;
}

const SpaCaseOfNeed = {
    name: "SpaCaseOfNeed",
    computed: {
        objectDetails: {
            get(this: SpaCaseOfNeed) { return this.$store.state.details || {}; },
        },
    },
} as ComponentOptions<SpaCaseOfNeed>;

export { SpaCaseOfNeed };



// WEBPACK FOOTER //
// ./src/components/spa-caseOfNeed.ts